import { render, staticRenderFns } from "./ParamScaleRangeEdit.vue?vue&type=template&id=1b139070&scoped=true"
import script from "./ParamScaleRangeEdit.vue?vue&type=script&lang=js"
export * from "./ParamScaleRangeEdit.vue?vue&type=script&lang=js"
import style0 from "./ParamScaleRangeEdit.vue?vue&type=style&index=0&id=1b139070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b139070",
  null
  
)

export default component.exports